import type { CdnAssetPath } from './cdnAssets.generated.types';

// Kept equal to CDN_BASE_URL in scripts/cdn-assets/constants.ts (asserted in cdn.spec.ts).
export const CDN_BASE_URL = 'https://withjoy.com/assets/public';

// 'joy-web/x/door.png' (v1) → '<CDN_BASE_URL>/joy-web/x/door.png'; '?v=2' → '…/door-v2.png'. Every version is its own S3 file.
// Same rule as toVersionedKey in scripts/cdn-assets/assetPath.ts (asserted in cdn.spec.ts).
export const cdn = (assetPath: CdnAssetPath): string => {
  const literal: string = assetPath;
  const [filePath, version] = literal.split('?v=');
  const versionedFilePath = version === undefined ? filePath : filePath.replace(/(\.\w+)$/, `-v${version}$1`);
  return `${CDN_BASE_URL}/${versionedFilePath}`;
};
